import { ONLINE_FEATURES, REGIONS } from "@/data/site";
import { ButtonLink, Eyebrow, FadeIn } from "@/components/blocks";

export default function Online() {
  return (
    <section data-testid="online-coaching" className="bg-ink px-6 py-28 text-bone sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow>Live Virtual Delivery</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            Your coach. Live. <span className="text-ash">Wherever you are.</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ash sm:text-lg">
            Every session is delivered live over private video — built to work across home setups,
            gyms, hotel rooms and international time zones.
          </p>
        </FadeIn>

        <div className="mt-16 grid gap-px border border-bone/15 bg-bone/15 sm:grid-cols-2 lg:grid-cols-3">
          {ONLINE_FEATURES.map((f, i) => (
            <FadeIn key={f} delay={i * 0.06} className="card-lift border border-white/5 bg-coal p-8">
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-lime">{String(i + 1).padStart(2, "0")}</p>
              <p className="mt-5 font-display text-lg font-black uppercase tracking-tight sm:text-xl">{f}</p>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.15} className="mt-14 flex flex-wrap items-center gap-x-4 gap-y-2">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ash">Coaching clients in</span>
          {REGIONS.map((r) => (
            <span key={r} className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/80">
              {r}
              <span className="ml-4 text-lime">/</span>
            </span>
          ))}
        </FadeIn>

        <FadeIn delay={0.2} className="mt-20 border-t border-bone/10 pt-16">
          <p className="font-display text-[10vw] font-black uppercase leading-[0.9] tracking-tight sm:text-[6.5vw]">
            One standard. <span className="text-lime">Anywhere.</span>
          </p>
          <div className="mt-12">
            <ButtonLink to="/start" variant="lime" testid="online-cta-start">
              Book Your Live Video Assessment
            </ButtonLink>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
